import React, { useState } from "react";
import LabelAndCheckbox from "../../common/form/labelAndCheckbox";
import Button from "../../common/button/button";
import { setError } from "../../common/toast/toast";
import Row from "../../common/layout/row";
import ContentCardHeader from "../../common/template/contentCardHeader";
import Select from "../../common/form/select";
import { LabelSelectUcIconeGestor } from "../../common/form/LabelSelectUcIconeGestor";
import Grid from "../../common/layout/grid";
import { ModalFiltrosFaturasAdmEnergia } from "./ModalFiltrosFaturasAdmEnergia";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";

import { getListaFaturasAdm, setFiltro, getListaUnidadeConsumidora } from "../faturaActions";

function FiltrosFaturasAdmEnergiaComponent(props) {
    const [modalFiltrosAberto, setModalFiltrosAberto] = useState(false);
    return (
        <>
            <ModalFiltrosFaturasAdmEnergia visible={modalFiltrosAberto} handleClose={() => setModalFiltrosAberto(false)} {...props} />
            <ContentCardHeader>
                <Row style={{ padding: 7 }}>
                    {props.usuarioLogado && !props.usuarioLogado.acesso_cliente ? (
                        <Select
                            readOnly={props.aguardando}
                            name="id_cliente"
                            options={props.listaCliente}
                            label="Cliente"
                            cols="12 6 3 3"
                            placeholder="Selecione o Cliente"
                            value={props.filtro.id_cliente}
                            onChange={(value) => {
                                if (!parseInt(props.filtro.ano) && !parseInt(props.filtro.mes) && !parseInt(value) && !props.filtro.unidades_consumidoras.length) {
                                    return setError("Selecione um cliente, uma UC ou algum período para poder limpar o filtro");
                                }
                                props.setFiltro({ ...props.filtro, id_cliente: value, unidades_consumidoras: [] });
                            }}
                        />
                    ) : null}

                    <Select
                        readOnly={props.aguardando}
                        name="ano"
                        options={Array.from({ length: new Date().getFullYear() - 2015 + 1 }, (v, i) => ({
                            id: 2015 + i,
                            valor: 2015 + i,
                        }))}
                        label="Ano"
                        cols="12 6 2 2"
                        placeholder="Selecione o ano"
                        value={props.filtro.ano}
                        onChange={(value) => {
                            if (!parseInt(props.filtro.id_cliente) && !parseInt(props.filtro.mes) && !parseInt(value) && !props.filtro.unidades_consumidoras.length) {
                                return setError("Selecione um cliente, uma UC ou algum período para poder limpar o filtro");
                            }
                            const novoFiltro = {...props.filtro, ano: value};
                            props.setFiltro(novoFiltro);
                            props.getListaUnidadeConsumidora(novoFiltro);
                        }}
                    />

                    <Select
                        readOnly={props.aguardando}
                        name="mes"
                        options={props.listaMeses}
                        label="Mês"
                        cols="12 6 2 2"
                        placeholder="Selecione o mês"
                        value={props.filtro.mes}
                        onChange={(value) => {
                            if (!parseInt(props.filtro.id_cliente) && !parseInt(props.filtro.ano) && !parseInt(value) && !props.filtro.unidades_consumidoras.length) {
                                return setError("Selecione um cliente, uma UC ou algum período para poder limpar o filtro");
                            }
                            const novoFiltro = {...props.filtro, mes: value};
                            props.setFiltro(novoFiltro);
                            props.getListaUnidadeConsumidora(novoFiltro);
                        }}
                    />

                    <Select
                        readOnly={props.aguardando}
                        name="geracao"
                        options={props.listaProducaoSolar}
                        label="Geração Solar"
                        cols="12 6 2 2"
                        placeholder="Selecione o tipo"
                        value={props.filtro.geracao_solar}
                        onChange={(value) => {
                            props.setFiltro({ ...props.filtro, geracao_solar: value });
                        }}
                    />

                    <Grid cols="6 6 3 3">
                        <Row style={{ paddingLeft: 12, paddingBottom: 12 }}>
                            <b>Tipo de Atividade</b>
                        </Row>
                        <Row style={{ alignItems: "center" }}>
                            <LabelAndCheckbox
                                readOnly={props.aguardando}
                                gridDisplay="flex"
                                gridJustifyContent={window.innerWidth < 400 ? "start" : "center"}
                                gridAlignItems="end"
                                style={{ marginLeft: 12 }}
                                label="Irrigante"
                                cols="12 12 4 4"
                                value={props.filtro.irrigante}
                                onChange={() => {
                                    props.setFiltro({ ...props.filtro, irrigante: !props.filtro.irrigante });
                                }}
                            />
                            <LabelAndCheckbox
                                readOnly={props.aguardando}
                                gridDisplay="flex"
                                gridJustifyContent={window.innerWidth < 400 ? "start" : "center"}
                                gridAlignItems="end"
                                style={{ marginLeft: 12 }}
                                label="Não-Irrigante"
                                cols="12 12 8 8"
                                value={props.filtro.naoIrrigante}
                                onChange={() => {
                                    props.setFiltro({ ...props.filtro, naoIrrigante: !props.filtro.naoIrrigante });
                                }}
                            />
                        </Row>
                    </Grid>

                    <Select
                        readOnly={props.aguardando}
                        options={(props.listaUnidadeConsumidora || []).map((uc) => ({...uc, valor: props.filtro.tipo_filtro_uc === "medidor" && uc.numero_medidor ? `${uc.valor} - Medidor: ${uc.numero_medidor}`: uc.valor,}))}
                        label={
                            <div
                                style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    gap: 20,
                                    alignItems: "center",
                                    width: "100%",
                                    flexWrap: window.innerWidth < 400 ? "wrap" : "nowrap",
                                    height: window.innerWidth < 400 ? "auto" : "22px",
                                    lineHeight: "22px",
                                }}
                            >
                                <div style={{ whiteSpace: "nowrap" }}>
                                    <LabelSelectUcIconeGestor
                                        isMulti={true}
                                        filtro={props.filtro}
                                        listaUnidadeConsumidora={(props.listaUnidadeConsumidora || []).map((uc) => ({...uc, valor: props.filtro.tipo_filtro_uc === "medidor" ? uc.valor : uc.valor.split(" - Medidor:")[0],}))}
                                        setExibirModal={(ucFiltro) => props.setState({...props.filtroState, exibirModalGestorConcessionaria: true, itemSelecionado: ucFiltro,})}
                                    />
                                </div>
                                <div
                                    style={{
                                        whiteSpace: "nowrap",
                                        display: "flex",
                                        alignItems: "center",
                                        paddingTop: "6px",
                                    }}
                                >
                                    <LabelAndCheckbox
                                        readOnly={props.aguardando}
                                        type="checkbox"
                                        label="Número do Medidor"
                                        value={props.filtro.tipo_filtro_uc === "medidor"}
                                        onChange={() => {props.setFiltro({...props.filtro, tipo_filtro_uc: props.filtro.tipo_filtro_uc === "medidor" ? "unidade" : "medidor",});}}
                                    />
                                </div>
                            </div>
                        }
                        cols="12 12 5 5"
                        placeholder="Selecione as UCs"
                        isMulti={true}
                        value={(props.filtro.unidades_consumidoras || []).map((ucSelecionada) => {
                            const idSelecionado = ucSelecionada.value !== undefined && ucSelecionada.value !== null ? ucSelecionada.value : ucSelecionada.id;
                            const ucAtualizada = (props.listaUnidadeConsumidora || []).find((uc) => {
                                const idUc = uc.value !== undefined && uc.value !== null ? uc.value : uc.id;
                                return idUc == idSelecionado;
                            });
                            if (!ucAtualizada) return ucSelecionada;
                            const valorAtualizado = props.filtro.tipo_filtro_uc === "medidor" && ucAtualizada.numero_medidor ? `${ucAtualizada.valor} - Medidor: ${ucAtualizada.numero_medidor}` : ucAtualizada.valor;
                            return {...ucSelecionada, ...ucAtualizada, value: idSelecionado, label: valorAtualizado, valor: valorAtualizado};
                        })}
                        onChange={(ucsSelecionadas) => {
                            if (!parseInt(props.filtro.id_cliente) && !parseInt(props.filtro.mes) && !parseInt(props.filtro.ano) && !ucsSelecionadas.length) {
                                return setError("Selecione um cliente, uma UC ou algum período para poder limpar o filtro");
                            }
                            props.setFiltro({ ...props.filtro, unidades_consumidoras: [...ucsSelecionadas] });
                        }}
                    />
                    <Select
                        readOnly={props.aguardando}
                        name="id_usuario_responsavel"
                        options={props.listaUsuarioAdministrador || []}
                        label="Analista Responsável"
                        cols="12 12 2 2"
                        placeholder="Todos"
                        value={props.filtroState.idUsuarioResponsavel}
                        onChange={(value) => {
                            props.setState({ ...props.filtroState, idUsuarioResponsavel: value });
                        }}
                    />
                    <Select
                        readOnly={props.aguardando}
                        name="id_concessionaria"
                        options={props.listaConcessionaria}
                        label="Concessionária"
                        cols="12 12 2 2"
                        placeholder="Selecione a concessionaria"
                        value={props.filtro.id_concessionaria}
                        onChange={(id_concessionaria) => {
                            props.setFiltro({ ...props.filtro, id_concessionaria });
                        }}
                    />
                    <Select
                        readOnly={props.aguardando}
                        name="id_grupo_faturamento"
                        options={props.listaGrupoFaturamento}
                        label="Tipo de Faturamento"
                        cols="12 12 3 3"
                        placeholder="Selecione o tipo de faturamento"
                        value={props.filtro.id_grupo_faturamento}
                        onChange={(id_grupo_faturamento) => {
                            props.setFiltro({ ...props.filtro, id_grupo_faturamento });
                        }}
                    />
                </Row>
                <Row style={{ padding: 7 }}>
                    <Grid cols="12 12 4 2" style={{ display: "flex", justifyContent: "center", paddingBlock: 8, margin: 0, cursor: "pointer" }}>
                        <Button
                            title="Filtros"
                            disabled={props.aguardando}
                            icon="fas fa-filter"
                            text="Filtros"
                            type={"light"}
                            solid={true}
                            forceBoxShadow={true}
                            event={() => setModalFiltrosAberto(true)}
                        />
                    </Grid>
                    {(props.buttons || []).map((botao, i) => (
                        <Grid key={i} cols="12 12 4 2" style={{ display: "flex", justifyContent: "center", paddingBlock: 8, margin: 0, cursor: "pointer" }}>
                            {botao}
                        </Grid>
                    ))}
                </Row>
            </ContentCardHeader>
        </>
    );
}
const mapStateToProps = (state) => {
    return {
        usuarioLogado: state.auth.usuarioLogado,
        aguardando: state.fatura.aguardando,
        filtro: state.fatura.filtro,
        listaMeses: state.fatura.listaMeses,
        listaCliente: state.fatura.listaCliente,
        listaProducaoSolar: state.fatura.listaProducaoSolar,
        listaConcessionaria: state.fatura.listaConcessionaria,
        listaGrupoFaturamento: state.cliente.listaGrupoFaturamento,
    };
};

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            setFiltro,
            getListaFaturasAdm,
            getListaUnidadeConsumidora,
        },
        dispatch
    );
const FiltrosFaturasAdmEnergia = connect(mapStateToProps, mapDispatchToProps)(FiltrosFaturasAdmEnergiaComponent);
export { FiltrosFaturasAdmEnergia };
